<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input v-model="search.name" clearable placeholder="条码号" class="filter-item" style="width: 200px;" @keyup.enter.native="handleFilter"/>
      <el-input v-model="search.user" clearable placeholder="借用人" class="filter-item" style="width: 200px;" @keyup.enter.native="handleFilter"/>
      <el-button v-waves type="primary" class="filter-item" icon="el-icon-search" @click="handleFilter">查询</el-button>
      <el-button v-waves class="filter-item" icon="el-icon-edit" @click="handleAdd">添加</el-button>
    </div>

    <el-table class="tbl" v-loading="loading" :key="tableKey" :data="list" border fit highlight-current-row style="width: 100%;">
      <el-table-column label="条码号" prop="sn" fixed align="center" width="150px"></el-table-column>
      <el-table-column label="当前状态" align="center" width="150px">
        <template slot-scope="props">
          <span :class="'w' + props.row.status">{{ props.row.status | statusFilter }}</span>
        </template>
      </el-table-column>
      <el-table-column label="购买日期" prop="purchase"></el-table-column>
      <el-table-column label="品牌" prop="brand"></el-table-column>
      <el-table-column label="型号" prop="ledge"></el-table-column>
      <el-table-column label="进样针数" prop="pin" align="center" width="100px"></el-table-column>
      <el-table-column label="离子试剂" prop="ion" align="center" width="100px">
        <template slot-scope="props">
          <span>{{ props.row.ion ? '是' : '否' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="当前借用人" prop="user"></el-table-column>

      <el-table-column label="操作" align="center" width="100" fixed="right" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-tooltip content="借用历史" class="item" effect="dark" placement="bottom">
            <el-button type="text" class="btn-text" @click="handleHistory(scope.row)">
              <svg-icon icon-class="state"/>
            </el-button>
          </el-tooltip>
          <el-tooltip content="编辑" class="item" effect="dark" placement="bottom">
            <el-button type="text" class="btn-text" @click="handleEdit(scope.row)">
              <svg-icon icon-class="edit"/>
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container right">
      <el-pagination v-show="total > search.size" :current-page="search.page" :page-size="search.size" :total="total" layout="total, prev, pager, next" @current-change="handleCurrentChange"/>
    </div>

    <el-dialog class="dia" :title="!temp.id? '添加': '编辑'" :visible.sync="dia.edit" top="1vh">
      <el-form ref="dataForm" :rules="rules" :model="temp" label-position="left" label-width="120px" style="max-width: 400px; margin-left:50px;">
        <el-form-item label="条码号" prop="sn">
          <el-input v-model="temp.sn" placeholder="请填写序列号，添加后不可修改" v-if="!temp.id" />
          <span v-else>{{ temp.sn }}</span>
        </el-form-item>
        <el-form-item label="购买日期" prop="purchase">
          <el-date-picker class="cal" v-model="temp.purchase" type="date" clearable placeholder="请选购买日期"></el-date-picker>
        </el-form-item>
        <el-form-item label="价格" prop="price">
          <el-input-number v-model="temp.price" placeholder="请填写价格"/>
        </el-form-item>
        <el-form-item label="品牌" prop="brand">
          <el-input v-model="temp.brand" placeholder="请填写品牌"/>
        </el-form-item>
        <el-form-item label="描述" prop="note">
          <el-input v-model="temp.note" placeholder="请填写描述"/>
        </el-form-item>
        <el-form-item label="型号" prop="ledge">
          <el-input v-model="temp.ledge" placeholder="请填写型号"/>
        </el-form-item>
        <el-form-item label="进样针数" prop="pin">
          <el-input v-model="temp.pin" placeholder="请填写进样针数"/>
        </el-form-item>
        <el-form-item label="离子试剂" prop="ion">
          <el-radio-group v-model="temp.ion">
            <el-radio :label="0">否</el-radio>
            <el-radio :label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="状态" prop="status" v-if="temp.id > 0">
          <el-select class="filter-item" v-model="temp.status" clearable placeholder="请选择状态">
            <el-option v-for="kv in option.status" :key="kv.k" :label="kv.v" :value="kv.k"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="报废原因" prop="scrap_why" v-if="temp.status == 4">
          <el-input v-model="temp.scrap_why" placeholder="请填写报废原因"/>
        </el-form-item>
        <el-form-item label="报废人" prop="scrap_who" v-if="temp.status == 4">
          <el-input v-model="temp.scrap_who" placeholder="请填写报废人"/>
        </el-form-item>
      </el-form>
       <div slot="footer" class="dialog-footer">
         <el-button @click="dia.edit = false">取消</el-button>
         <el-button type="primary" @click="saveData">确定</el-button>
       </div>
     </el-dialog>
     <!-- edit -->

     <el-dialog class="dia" :title="'色谱柱借用历史(' + temp.sn + ')'" :visible.sync="dia.history" top="1vh">
       <el-table class="tbl" v-loading="loading" :data="history" border fit highlight-current-row style="width: 100%;">
         <el-table-column label="领用日期" prop="start" align="center" width="150px"></el-table-column>
         <el-table-column label="归还时间" prop="end" align="center" width="150px"></el-table-column>
         <el-table-column label="借用人" prop="user" align="center" width="150px"></el-table-column>
         <el-table-column label="使用项目" prop="proj" align="center" width="150px"></el-table-column>
         <el-table-column label="备注" prop="note" align="center"></el-table-column>
       </el-table>
     </el-dialog>

  </div>
</template>

<script>
import waves from '@/directive/waves'

const option = {
  status: [{k: 0, v: '闲置'}, {k: 1, v: '入库'}, {k: 2, v: '出库'}, {k: 3, v: '还入待确认'}, {k: 4, v: '废弃'}],
}

export default {
  name: 'Stats',
  directives: {
    waves
  },
  filters: {
    statusFilter(key) {
      if (key === 0) {
        return '闲置'
      }
      let d = option.status.find(row => row.k == key)
      return d? d.v: '-'
    },
  },
  data() {
    return {
      tableKey: 0,
      list: [],
      total: 0,
      loading: false,
      search: {
        page: 1,
        size: 12,
        name: ''
      },
      option: option,
      dia: {
        edit: false,
        history: false,
      },
      history: [],
      temp: {},
      rules: {
        sn: [{ required: true, message: '请填写条码号', trigger: 'blur' }],
        purchase: [{ required: true, message: '请选择购买日期', trigger: 'blur' }],
        price: [{ required: true, message: '请填写价格', trigger: 'blur' }],
        brand: [{ required: true, message: '请填写品牌', trigger: 'blur' }],
        pin: [{ required: true, message: '请填写进样针数', trigger: 'blur' }],
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      const _t = this
      _t.loading = true
      _t.$http.post('/api/chro/w-index/', _t.search).then(resp => {
        _t.list = resp.data.list
        _t.total = resp.data.total
        setTimeout(() => {
          _t.loading = false
        }, 500)
      }).catch(() => {
        setTimeout(() => {
          _t.loading = false
        }, 500)
      })
    },
    handleFilter() {
      this.search.page = 1
      this.getList()
    },
    handleCurrentChange(val) {
      this.search.page = val
      this.getList()
    },
    handleAdd() {
      this.temp = {} 
      this.dia.edit = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleHistory(row) {
      const _t = this;
      _t.loading = true
      _t.temp = row;
      _t.dia.history = true
      _t.$http.post('/api/chro/history/', {id: row.id}).then(resp => {
        _t.history = resp.data
        setTimeout(() => {
          _t.loading = false
        }, 500)
      }).catch(() => {
        setTimeout(() => {
          _t.loading = false
        }, 500)
      })
    },
    handleEdit(row) {
      this.temp = Object.assign({}, row)
      this.dia.edit = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    saveData() {
      const _t = this
      _t.$refs['dataForm'].validate((valid) => {
        if (valid) {
          _t.$http.post('/api/chro/save', _t.temp).then(function(resp) {
            if (resp.code === 0) {
              _t.$message.success(resp.msg)
              _t.dia.edit = false
              _t.getList()
            }
          })
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.tbl {
  .w1 {
    color: #67C23A;
  }
  .w2 {
    color: #E6A23C;
  }
  .w3 {
    color: #409EFF;
  }
  .w4 {
    color: #909399;
  }
}
</style>
